export default __webpack_public_path__ + "c955efb55a6e70190795d78c792833e3.gif";